import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { LandingNav } from '@/components/landing/LandingNav';
import { Hero } from '@/components/landing/Hero';
import { Story } from '@/components/landing/Story';
import { Visit } from '@/components/landing/Visit';
import { Experience } from '@/components/landing/Experience';
import { SampleMenu, MENU_SECTIONS } from '@/components/landing/SampleMenu';
import { Gallery } from '@/components/landing/Gallery';
import { Testimonials } from '@/components/landing/Testimonials';
import { CorporateTeaser } from '@/components/landing/CorporateTeaser';
import { Footer } from '@/components/landing/Footer';
import { SeoFooter } from '@/components/landing/SeoFooter';
import { SEO } from '@/components/landing/SEO';
import { BRAND, IMAGES, KEYWORDS } from '@/components/landing/config';
export default function LandingPage() {
    const title = `رستوران آرشه | کافه و رستوران در سهروردی شمالی تهران`;
    const description = 'رستوران آرشه (Arshe) در خیابان خرمشهر سهروردی شمالی تهران — کافه، صبحانه، ناهار و شام با غذای ایرانی و فرنگی. بیش از ۱۴ سال تجربه، فضایی آرام. همچنین سامانه رزرو غذای کارمندی برای شرکت‌ها.';
    return (_jsxs("div", { className: "bg-white dark:bg-gray-950", children: [_jsx(SEO, { title: title, description: description, path: "/", image: IMAGES.heroBg, keywords: [
                    'رستوران آرشه',
                    'آرشه رستوران',
                    'کافه آرشه',
                    'آرشه',
                    'arshe restaurant',
                    'arshe tehran',
                    'کافه رستوران آرشه',
                    ...KEYWORDS,
                    'کافه سهروردی شمالی',
                    'رستوران خرمشهر تهران',
                    'رستوران سهروردی',
                    'صبحانه سهروردی',
                    'کافه بهشتی',
                    'رزرو غذای کارمندی',
                    'سامانه رزرو غذا',
                ], schemas: [
                    {
                        '@context': 'https://schema.org',
                        '@type': ['Restaurant', 'CafeOrCoffeeShop', 'LocalBusiness'],
                        '@id': `${BRAND.url}#restaurant`,
                        name: 'رستوران آرشه',
                        alternateName: [
                            BRAND.name, // کافه رستوران آرشه
                            'آرشه رستوران',
                            'کافه آرشه',
                            'آرشه',
                            BRAND.nameEn, // Cafe and Restaurant ARSHE
                            'Arshe Restaurant',
                            'Arshe',
                        ],
                        description,
                        url: BRAND.url,
                        telephone: BRAND.phone,
                        email: BRAND.email,
                        servesCuisine: ['Persian', 'Iranian', 'Mediterranean', 'International'],
                        priceRange: '$$',
                        image: [IMAGES.heroBg, IMAGES.about, ...IMAGES.gallery.slice(0, 4)],
                        address: {
                            '@type': 'PostalAddress',
                            streetAddress: BRAND.address,
                            addressLocality: BRAND.city,
                            addressRegion: BRAND.region,
                            postalCode: BRAND.postalCode,
                            addressCountry: BRAND.country,
                        },
                        openingHoursSpecification: [
                            { '@type': 'OpeningHoursSpecification', dayOfWeek: ['Saturday', 'Sunday', 'Monday', 'Tuesday', 'Wednesday'], opens: '11:00', closes: '23:00' },
                            { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Thursday', opens: '11:00', closes: '24:00' },
                            { '@type': 'OpeningHoursSpecification', dayOfWeek: 'Friday', opens: '12:00', closes: '23:00' },
                        ],
                        sameAs: [BRAND.instagram],
                        areaServed: { '@type': 'City', name: BRAND.city },
                        hasMenu: { '@id': `${BRAND.url}#menu` },
                    },
                    {
                        '@type': 'Menu',
                        '@id': `${BRAND.url}#menu`,
                        name: `منوی ${BRAND.name}`,
                        inLanguage: 'fa-IR',
                        hasMenuSection: MENU_SECTIONS.map((s) => ({
                            '@type': 'MenuSection',
                            name: s.title,
                            hasMenuItem: s.items.map((it) => ({
                                '@type': 'MenuItem',
                                name: it.name,
                                description: it.desc,
                            })),
                        })),
                    },
                    {
                        '@context': 'https://schema.org',
                        '@type': 'WebSite',
                        '@id': `${BRAND.url}#website`,
                        url: BRAND.url,
                        name: BRAND.name,
                        alternateName: ['رستوران آرشه', 'آرشه'],
                        inLanguage: 'fa-IR',
                        publisher: { '@id': `${BRAND.url}#restaurant` },
                        potentialAction: {
                            '@type': 'SearchAction',
                            target: `${BRAND.url}/menu?q={search_term_string}`,
                            'query-input': 'required name=search_term_string',
                        },
                    },
                    {
                        '@type': 'Service',
                        '@id': `${BRAND.url}#corporate-service`,
                        serviceType: 'Online employee food reservation / Corporate catering',
                        name: 'سامانه رزرو غذای کارمندی آرشه',
                        alternateName: 'رزرو غذای کارمندی آنلاین',
                        url: `${BRAND.url}/companies`,
                        provider: { '@id': `${BRAND.url}#restaurant` },
                        areaServed: { '@type': 'City', name: BRAND.city },
                        audience: { '@type': 'BusinessAudience', name: 'شرکت‌ها و سازمان‌ها' },
                    },
                ] }), _jsx(LandingNav, { variant: "home" }), _jsxs("main", { children: [_jsx(Hero, {}), _jsx(Story, {}), _jsx(Visit, {}), _jsx(Experience, {}), _jsx(SampleMenu, {}), _jsx(Gallery, {}), _jsx(Testimonials, {}), _jsx(CorporateTeaser, {})] }), _jsx(SeoFooter, {}), _jsx(Footer, {})] }));
}
